import { create } from "zustand";

export const useNoteStore = create<any>((set) => ({
  note: '',
  updateNote: (note: string) => set(() => ({ note })),
}));
export const useCustomerStore = create<any>((set) => ({
  customer: {},
  updateCustomer: (customer: {}) => set(() => ({ customer })),
}));
export const useWagesStore = create<any>((set) => ({
  wages: 0,
  updateWages: (wages: number) => set(() => ({ wages })),
}));
export const useOverAllDiscountStore = create<any>((set) => ({
  discount: 0,
  discountType: "",
  updateDiscount: (discount: number) => set(() => ({ discount })),
  updateDiscountType: (discountType: string) => set(() => ({ discountType })),
}));
export const useTotalStore = create<any>((set) => ({
  total: {},
  updateTotal: (total: {}) => set(() => ({ total })),
}));
export const useOrderId = create<any>((set) => ({
  orderId: '',
  updateOrderId: (orderId: string) => set(() => ({ orderId })),
}));
export const useSearchProduct = create<any>((set) => ({
  searchProduct: '',
  updateSearchProduct: (searchProduct: string) => set(() => ({ searchProduct })),
}));